export default "__VITE_ASSET__D$90DV4C__"